<template>
  <div>
    <div style="display: flex; justify-content: space-between; gap: 15px">
      <div style="width: 300px">
        <v-select
          v-model="currentStatus"
          :items="dropdownStatuses"
          label="Статус блокировки"
          color="accent"
          item-title="title"
        >
          <template #selection="{ item }">
            {{ item.title }}
          </template>

          <template #item="{ item }">
            {{ item.title }}
          </template>
        </v-select>
      </div>

      <div style="display: flex; gap: 30px">
        <div style="width: 300px">
          <v-text-field
            v-model="searchEmail"
            class="search-input"
            color="accent"
            append-icon="search"
            label="Email"
            single-line
            hide-details
          />

          <v-text-field
            v-model="searchName"
            class="search-input"
            color="accent"
            append-icon="search"
            label="Ник"
            single-line
            hide-details
          />

          <v-text-field
            v-model="searchId"
            class="search-input"
            color="accent"
            append-icon="search"
            label="Id"
            single-line
            hide-details
            type="number"
          />
        </div>

        <div style="width: 300px">
          <v-text-field
            v-model="fingerprintId"
            class="search-input"
            color="accent"
            append-icon="search"
            label="Fingerprint key"
            single-line
            hide-details
          />

          <v-text-field
            v-model="searchIdSocial"
            class="search-input"
            color="accent"
            append-icon="search"
            label="Id соц. сети"
            single-line
            hide-details
            type="number"
          />

          <v-text-field
            v-model="searchIp"
            class="search-input"
            color="accent"
            append-icon="search"
            label="Ip"
            single-line
            hide-details
          />
        </div>
      </div>
    </div>

    <paginated-table
      ref="paginatedTable"
      :key="`${searchName}_${pagination.sortBy}_${pagination.descending ? '1' : '0'}`"
      :items="items"
      :headers="headers"
      :loading="loading"
      :pullFunction="pullFunction"
      :pagination.sync="pagination"
    >
      <template #headerCell="props">
        <th v-if="props.header.text === 'Дата блокировки'" style="cursor: pointer" @click="sortReplenishFunc">
          {{ props.header.text }}
          <v-icon v-if="replenishDateSort" small>
            {{ replenishDateSort === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up' }}
          </v-icon>
        </th>

        <div
          v-else-if="props.header.text === 'Баланс' || props.header.text === 'User ID'"
          style="display: inline"
          @click="replenishDateSort = null"
        >
          {{ props.header.text }}
        </div>
      </template>

      <template #items="props">
        <UserItem :item="props.item" @update-table="pullFunction(1)" @copied="wasCopied = true" />
      </template>
    </paginated-table>

    <v-snackbar v-model="wasCopied" color="green">
      <p style="margin: 0 auto">Скопировано!</p>
    </v-snackbar>
  </div>
</template>

<script>
import lodash from 'lodash'
import UserItem from './UserItem'
import { getUsers } from '../../../../../api/user'
import PaginatedTable from '@/components/PaginatedTable.vue'
import User from '../../../../../helpers/user'
import PaymentItem from '@/components/common/Table/PaymentsTable/PaymentItem.vue'

export default {
  name: 'UsersTable',
  components: {
    PaymentItem, PaginatedTable, UserItem
  },
  data () {
    return {
      replenishDateSort: null,
      wasCopied: false,
      searchEmail: '',
      searchName: '',
      searchIp: '',
      searchId: '',
      searchIdSocial: '',
      fingerprintId: '',
      pagination: {
        sortBy: 'id',
        descending: false,
        page: 1,
        totalItems: 1
      },
      loading: true,
      page: 1,
      headers: [
        { text: 'User ID', value: 'id' },
        {
          text: 'Ник',
          value: 'name',
          sortable: false
        },
        {
          text: 'Email',
          value: 'email',
          sortable: false
        },
        {
          text: 'Подтвержден',
          value: 'verification_status',
          sortable: false
        },
        {
          text: 'Дата регистрации',
          value: 'created_at',
          sortable: false
        },
        {
          text: 'Аккаунт ВК',
          value: 'social_network_accounts[0].link',
          sortable: false
        },
        {
          text: 'Категория пользователя',
          value: 'referral_programs[0].referral_category.name',
          sortable: false
        },
        { text: 'Баланс', value: 'accounts[0].value' },
        {
          text: '% реф. прог.',
          value: 'referral_programs[0].percent',
          sortable: false
        },
        {
          text: 'Кол-во рефер.',
          value: 'referrals_count',
          sortable: false
        },
        {
          text: 'Fingerprint',
          value: 'fingerprints[0].key'
        },
        {
          text: 'Снял/Пополнил',
          value: '',
          sortable: false
        },
        {
          text: 'Дата блокировки',
          value: 'replenishment_blocked_at',
          sortable: false
        },
        {
          text: 'Блокировка пополнения',
          value: '',
          sortable: false
        },
        {
          text: 'Блокировка вывода',
          value: 'is_permanent_blocking_withdrawal',
          sortable: false
        },
        {
          text: 'Заблокировать',
          value: '',
          sortable: false
        },
        {
          text: 'Подробнее',
          value: '',
          sortable: false
        }
      ],
      dropdownStatuses: [
        {
          title: 'Все',
          value: null
        },
        {
          title: 'Нет',
          value: 0
        },
        {
          title: 'Временная',
          value: 1
        },
        {
          title: 'Постоянная',
          value: 2
        }
      ],
      currentStatus: null,
      items: []
    }
  },
  computed: {
    User () {
      return User
    }
  },
  watch: {
    replenishDateSort () {
      this.pullFunction(1)
    },
    currentStatus () {
      this.pullFunction(1)
    },
    searchEmail () {
      this.pullFunction(1)
      this.$refs.paginatedTable?.resetPagination()
    },
    searchName () {
      this.pullFunction(1)
      this.$refs.paginatedTable?.resetPagination()
    },
    searchId () {
      this.pullFunction(1)
      this.$refs.paginatedTable?.resetPagination()
    },
    searchIdSocial () {
      this.pullFunction(this.page)
      this.$refs.paginatedTable?.resetPagination()
    },
    fingerprintId () {
      this.pullFunction(this.page)
      this.$refs.paginatedTable?.resetPagination()
    },
    'pagination.sortBy': function () {
      this.pullFunction(1)
    },
    'pagination.descending': function () {
      this.pullFunction(1)
    },
    searchIp () {
      this.pullFunction(1)
      this.$refs.paginatedTable?.resetPagination()
    }
  },
  created () {
    this.pullFunction(1, '', '')
  },
  methods: {
    sortReplenishFunc () {
      if (!this.replenishDateSort) this.replenishDateSort = 'desc'
      else if (this.replenishDateSort === 'desc') this.replenishDateSort = 'asc'
      else this.replenishDateSort = null
    },
    pullFunction: lodash.debounce(async function (page) {
      let sort = null
      if (this.pagination.sortBy == 'accounts[0].value') {
        sort = `balance:${this.pagination.descending ? 'desc' : 'asc'}`
      } else if (this.replenishDateSort) {
        this.pagination.sortBy = ''
        sort = `replenishment_blocked_at:${this.replenishDateSort}`
      }
      this.page = page
      this.loading = true
      const { data } = await getUsers(
        26,
        (page - 1) * 25,
        this.searchEmail,
        this.searchName,
        sort,
        this.searchId,
        this.searchIdSocial,
        this.fingerprintId,
        this.searchIp,
        this.currentStatus
      )

      this.items = data.map(i => {
        if (i.referral_programs && i.referral_programs.length > 0) {
          switch (i.referral_programs[0].referral_category.name) {
            case 'regular':
              i.referral_programs[0].referral_category.name = 'Обычный'
              break
            case 'media':
              i.referral_programs[0].referral_category.name = 'Медиа'
              break
          }
          i.referral_programs[0].percent *= 100
        } else {
          i.referral_programs = [
            {
              referral_category: { name: 'Нет категории' },
              percent: 0
            }
          ]
        }
        return i
      })
      this.loading = false
    }, 300)
  }
}
</script>

<style scoped>
.search-input {
  margin-bottom: 10px;
}
</style>
